import React, { useCallback } from 'react';

import useDateRangeQuery, {
	type TRange,
	UseDateRangeQueryPropsType,
} from '@common/helpers/useRangeDateQuery';

import DateRangeCalendar, { DateRangeCalendarProps } from '.';

interface PropsType extends Omit<DateRangeCalendarProps, 'value' | 'onChange'> {
	useDateRangeProps?: UseDateRangeQueryPropsType;
}

function DateRangePickerWithSearchParams({ useDateRangeProps, ...props }: PropsType) {
	const { range, setRange } = useDateRangeQuery(useDateRangeProps);

	const handleRangeChange = useCallback((newRange: TRange) => {
		setRange(newRange);
	}, []);

	return <DateRangeCalendar value={range} onChange={handleRangeChange} {...props} />;
}

export default DateRangePickerWithSearchParams;
